import Tooltip from "@atlaskit/tooltip";
import CheckCircleIcon from "@atlaskit/icon/glyph/check-circle";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import EditorErrorIcon from "@atlaskit/icon/glyph/editor/error";
import Spinner from "@atlaskit/spinner";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import { jobStatus } from "../../constants/constants";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import Skeleton from "react-loading-skeleton";
import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
export const createHead = (withWidth, jobType) => {
  return {
    cells: [
      {
        key: "id",
        content: <div style={{ textAlign: "center" }}>Status</div>,
        isSortable: false,
        width: withWidth ? 5 : undefined,
      },
      {
        key: "event",
        content: "Original issue ID",
        isSortable: false,
        width: withWidth ? 16 : undefined,
      },
      {
        key: "NewissueID",
        content: "New issue ID",
        isSortable: false,
        width: withWidth ? 16 : undefined,
      },
      {
        key: "originalissuekey",
        content: "Original issue key",
        isSortable: false,
        width: withWidth ? 16 : undefined,
      },
      {
        key: "newissuekey",
        content: "Restored issue key",
        isSortable: false,
        width: withWidth ? 16 : undefined,
      },
      {
        key: "Statuscode",
        content: "Status code",
        isSortable: false,
        width: withWidth ? 30 : undefined,
      },
      jobType === "Quick" && {
        key: "Revyz event ID",
        content: "Revyz event ID",
        isSortable: false,
        width: withWidth ? 20 : undefined,
      },
    ],
  };
};

function createKey(input) {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
}

export const createCells = (
  restoreIssuesDetails,
  base_url,
  isLoading,
  jobType
) =>
  restoreIssuesDetails.map((data, index) => ({
    key: `row-${index}`,
    cells: [
      {
        key: createKey(data.issueRestoreStatus?.toString()),
        content: (
          <div style={{ textAlign: "center" }}>
            <Tooltip
              content={jobStatus[data.issueRestoreStatus]}
              position="left"
            >
              <div>
                {data.issueRestoreStatus === null && (
                  <QuestionCircleIcon size="small" />
                )}
                {data.issueRestoreStatus === "1" && (
                  <EmojiFrequentIcon size="small" />
                )}
                {data.issueRestoreStatus === "2" && <Spinner size="small" />}
                {data.issueRestoreStatus === "3" && (
                  <CheckCircleIcon primaryColor="green" size="small" />
                )}
                {data.issueRestoreStatus === "4" && (
                  <WarningIcon primaryColor="orange" size="small" />
                )}
                {data.issueRestoreStatus === "5" && (
                  <EditorErrorIcon primaryColor="red" size="small" />
                )}
              </div>
            </Tooltip>
          </div>
        ),
      },
      {
        key: createKey(data.originalIssueId ?? "-".toString()),
        content: <div>{data.originalIssueId ?? "-"}</div>,
      },
      {
        key: createKey(data.newIssueId ?? "-".toString()),
        content: data.newIssueId ?? "-",
      },
      {
        key: createKey(data.originalIssueKey ?? "-".toString()),
        content: (
          <div>
            {isLoading ? (
              <Skeleton width="25px" />
            ) : data.originalIssueKey === null ? (
              "-"
            ) : (
              <a
                target="_blank"
                href={`${base_url}/browse/${data.originalIssueKey}`}
                rel="noreferrer"
              >
                {data.originalIssueKey} <ShortcutIcon size="small" />
              </a>
            )}
          </div>
        ),
      },
      {
        key: createKey(data.newIssueKey ?? "-".toString()),
        content: (
          <div>
            {isLoading ? (
              <Skeleton width="25px" />
            ) : data.newIssueKey === null ? (
              "-"
            ) : (
              <a
                target="_blank"
                href={`${base_url}/browse/${data.newIssueKey}`}
                rel="noreferrer"
              >
                {data.newIssueKey} <ShortcutIcon size="small" />
              </a>
            )}
          </div>
        ),
      },
      {
        key: createKey("321" ?? "-".toString()),
        content: data.statusCodes === null ? "-" : data?.statusCodes,
        // <div style={{ display: "flex", flexDirection: "row" }}>
        //   {data.statusCodes === null || data.statusCodes === ""
        //     ? "-"
        //     : data.statusCodes.split("|").map((errorCode) => (
        //         <div>
        //           <a
        //             // replace below href's queryparams to direct to relevant section
        //             href="https://revyz.atlassian.net/l/cp/UcgTvKft"
        //             target="_blank"
        //             rel="noreferrer"
        //           >
        //             {errorCode}&nbsp;
        //             <ShortcutIcon size="small" />
        //           </a>
        //           &nbsp;
        //         </div>
        //       ))}
        // </div>
      },
      jobType === "Quick" && {
        key: createKey(
          data.webhookEventId?.toString() ??
            `webhookEventId+${index}`.toString()
        ),
        content: <div>{data.issueDetails?.webhookEventId ?? "-"}</div>,
      },
    ],
  }));
